import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function MainBookHero() {
  return <section className="relative min-h-[85vh] sm:min-h-[90vh] lg:min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-black via-dark-900 to-navy-900 pt-16 sm:pt-20 pb-16 sm:pb-24 lg:pb-32 px-4 sm:px-6" aria-label="Hero principal - Método CIERRE 90" data-id="element-403">
      {/* Animated background elements */}
      <div className="absolute inset-0" aria-hidden="true" data-id="element-404">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 bg-gold-500/10 rounded-full blur-[80px] sm:blur-[100px] lg:blur-[120px] animate-pulse" data-id="element-405"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 bg-navy-800/30 rounded-full blur-[80px] sm:blur-[100px] lg:blur-[120px] animate-pulse delay-1000" data-id="element-406"></div>
      </div>

      <div className="relative max-w-7xl mx-auto w-full" data-id="element-407">
        <article className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center" data-id="element-408">
          {/* Left: Content */}
          <motion.header initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left z-10" data-id="element-409">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-gold-500/10 border border-gold-500/30 mb-6 sm:mb-8 backdrop-blur-sm" role="status" aria-label="Nuevo lanzamiento" data-id="element-410">
              <span className="text-gold-500 font-bold uppercase tracking-wider text-xs sm:text-sm" data-id="element-411">
                Nuevo Lanzamiento
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-serif font-bold leading-[1.1] sm:leading-tight mb-4 sm:mb-6 tracking-tight" data-id="element-412">
              <span className="text-white block" data-id="element-413">ADIÓS AL</span>
              <span className="text-gradient-gold block mt-1 sm:mt-2" data-id="element-414">
                CAOS
              </span>
              <span className="text-white block text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2 sm:mt-4" data-id="element-415">
                POR EL ESTRÉS LABORAL
              </span>
            </h1>

            <p className="text-xl sm:text-2xl md:text-3xl text-gray-300 font-light mb-4 sm:mb-6 leading-relaxed" data-id="element-416">
              El Método CIERRE 90'
            </p>

            <p className="text-base sm:text-lg text-gray-400 mb-6 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-417">
              Este sistema está diseñado para reducir la saturación mental,
              mejorar el enfoque y cerrar tareas importantes{' '}
              <strong className="text-gold-500 font-semibold" data-id="element-418">
                sin forzar tu energía ni vivir en modo agotamiento
              </strong>
              .
            </p>
          </motion.header>

          {/* Right: Book Image */}
          <motion.figure initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative z-10 flex justify-center lg:justify-end" data-id="element-419">
            <div className="relative w-full max-w-[280px] sm:max-w-[350px] md:max-w-md" data-id="element-420">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gold-500/20 blur-[60px] sm:blur-[80px] rounded-full" aria-hidden="true" data-id="element-421"></div>

              {/* Main book image */}
              <img src="https://cdn.magicpatterns.com/uploads/nVi5D7PkQzVXACwNVXfAGp/EBOOK_PRINCIPAL.png" alt="Portada del ebook Adiós al Caos por el Estrés Laboral - Método CIERRE 90 para productividad sin agotamiento" className="relative w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" loading="eager" width="448" height="600" data-id="element-422" />
            </div>
          </motion.figure>
        </article>
      </div>

      {/* Scroll indicator - hidden on very small screens */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      delay: 1,
      duration: 2,
      repeat: Infinity
    }} className="hidden sm:block absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 text-gray-500" aria-label="Desplázate hacia abajo" role="img" data-id="element-423">
        <div className="w-5 h-8 sm:w-6 sm:h-10 border-2 border-gray-600 rounded-full flex justify-center p-1" data-id="element-424">
          <div className="w-1 h-2 bg-gold-500 rounded-full" data-id="element-425"></div>
        </div>
      </motion.div>
    </section>;
}